export class EFSRestoreDestination {
    'region';
    'restoreType';
    'itemsToRestore';
    'restoreToNewFileSystem';
    'fileSystemName';
    'subnetIds';
    'securityGroupIds';
    'encryptionKey';
    'performanceMode';
    'throughputMode';
    'provisionedThroughputMibps';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreType",
            "baseName": "restoreType",
            "type": "EFSRestoreDestinationRestoreTypeEnum",
            "format": ""
        },
        {
            "name": "itemsToRestore",
            "baseName": "itemsToRestore",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoreToNewFileSystem",
            "baseName": "restoreToNewFileSystem",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "fileSystemName",
            "baseName": "fileSystemName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetIds",
            "baseName": "subnetIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "performanceMode",
            "baseName": "performanceMode",
            "type": "EFSRestoreDestinationPerformanceModeEnum",
            "format": ""
        },
        {
            "name": "throughputMode",
            "baseName": "throughputMode",
            "type": "EFSRestoreDestinationThroughputModeEnum",
            "format": ""
        },
        {
            "name": "provisionedThroughputMibps",
            "baseName": "provisionedThroughputMibps",
            "type": "number",
            "format": "double"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EFSRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
export var EFSRestoreDestinationRestoreTypeEnum;
(function (EFSRestoreDestinationRestoreTypeEnum) {
    EFSRestoreDestinationRestoreTypeEnum["FullRestore"] = "fullRestore";
    EFSRestoreDestinationRestoreTypeEnum["ItemLevelRestore"] = "itemLevelRestore";
})(EFSRestoreDestinationRestoreTypeEnum || (EFSRestoreDestinationRestoreTypeEnum = {}));
export var EFSRestoreDestinationPerformanceModeEnum;
(function (EFSRestoreDestinationPerformanceModeEnum) {
    EFSRestoreDestinationPerformanceModeEnum["GeneralPurpose"] = "generalPurpose";
    EFSRestoreDestinationPerformanceModeEnum["MaxIo"] = "maxIO";
})(EFSRestoreDestinationPerformanceModeEnum || (EFSRestoreDestinationPerformanceModeEnum = {}));
export var EFSRestoreDestinationThroughputModeEnum;
(function (EFSRestoreDestinationThroughputModeEnum) {
    EFSRestoreDestinationThroughputModeEnum["Bursting"] = "bursting";
    EFSRestoreDestinationThroughputModeEnum["Provisioned"] = "provisioned";
    EFSRestoreDestinationThroughputModeEnum["Elastic"] = "elastic";
})(EFSRestoreDestinationThroughputModeEnum || (EFSRestoreDestinationThroughputModeEnum = {}));
